import React, { useEffect, useRef, useState } from "react";
import { useFormikContext } from "formik";
import { Box, Button, CircularProgress, MenuItem, TextField, Typography } from "@material-ui/core";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import { usePanelStyles } from "../FormFields/panel";

const MetaBusinessAssets = ({ whatsappId, compact = false }) => {
  const p = usePanelStyles();
  const { values, setFieldValue } = useFormikContext();
  const [assets, setAssets] = useState(null);
  const [accountId, setAccountId] = useState("");
  const [selectedPhone, setSelectedPhone] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const requestId = useRef(0);
  const t = key => i18n.t(`metaBusinessAssets.${key}`);

  useEffect(() => {
    requestId.current += 1;
    setAssets(null);
    setAccountId("");
    setSelectedPhone("");
    setError("");
    setBusy(false);
    return () => { requestId.current += 1; };
  }, [values.business_id, values.send_token, whatsappId]);

  const load = async (selectedAccount = "") => {
    const current = ++requestId.current;
    setBusy(true);
    setError("");
    setSelectedPhone("");
    setAccountId(selectedAccount);
    setAssets(null);
    try {
      const { data } = await api.post("/whatsapp/official/business-assets", {
        businessId: String(values.business_id || "").trim(),
        accessToken: String(values.send_token || "").trim(),
        ...(whatsappId ? { whatsappId } : {}),
        ...(selectedAccount ? { accountId: selectedAccount } : {})
      });
      if (current === requestId.current) setAssets(data);
    } catch (err) {
      if (current === requestId.current) {
        const key = err.response?.data?.error;
        setError(i18n.exists(`metaBusinessAssets.errors.${key}`) ? t(`errors.${key}`) : t("errors.default"));
      }
    } finally {
      if (current === requestId.current) setBusy(false);
    }
  };

  const choosePhone = event => {
    const phone = assets.phones.find(p => p.id === event.target.value);
    if (!phone) return;
    setSelectedPhone(phone.id);
    setFieldValue("waba_id", accountId);
    setFieldValue("phone_number_id", phone.id);
    setFieldValue("phone_number", phone.phoneNumber);
  };

  return (
    <Box mt={2} width="100%">
      {!compact && <h3 className={p.sectionTitle}>{t("title")}</h3>}
      <p className={p.sectionHint}>{compact ? "Selecione a conta e o número autorizados. Os campos abaixo serão preenchidos; a conexão só muda ao salvar." : t("description")}</p>
      <Box mt={1.5} mb={1.5}>
        <Button type="button" variant="outlined" color="primary"
          disabled={busy || !values.business_id || !values.send_token} onClick={() => load()}>
          {busy ? <CircularProgress size={18} /> : t("load")}
        </Button>
      </Box>
      {error && <Typography role="alert" variant="body2" color="error">{error}</Typography>}
      {assets && <>
        <div className={p.notice}>{assets.business.name} — {assets.business.id}</div>
        {assets.accounts.length === 0 ? <p className={p.help}>{t("emptyAccounts")}</p> : <TextField
          id="meta-business-account" select fullWidth variant="outlined" margin="dense" label={t("account")}
          value={accountId} onChange={e => load(e.target.value)} disabled={busy}>
          {assets.accounts.map(a => <MenuItem key={a.id} value={a.id}>{a.name} — {a.id}</MenuItem>)}
        </TextField>}
        {accountId && (assets.phones.length === 0 ? <p className={p.help}>{t("emptyPhones")}</p> : <TextField
          id="meta-business-phone" select fullWidth variant="outlined" margin="dense" label={t("phone")}
          value={selectedPhone} onChange={choosePhone} disabled={busy}>
          {assets.phones.map(phone => <MenuItem key={phone.id} value={phone.id}>
            {phone.displayPhoneNumber} — {phone.verifiedName || phone.id}
          </MenuItem>)}
        </TextField>)}
        {selectedPhone && <p className={p.help} role="status">{t("selected")}</p>}
      </>}
    </Box>
  );
};

export default MetaBusinessAssets;
